var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQatar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8_879)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_879",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2243 3L14.8667 4.11148L11.2243 5.21627L14.8667 6.32775L11.2243 7.43924L14.8667 8.55072L11.2243 9.6622L14.8667 10.7737L11.2243 11.8852L14.8667 12.9967L11.2243 14.1081L14.8667 15.2196L11.2243 16.3311L14.8667 17.4426L11.2243 18.5541L14.8667 19.6656L11.2243 20.777L14.8667 21.8885L11.2243 23H35.2819V3H11.2243Z",
    fill: "#691941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3V23H11.2243L14.8668 21.8885L11.2243 20.777L14.8668 19.6656L11.2243 18.5541L14.8668 17.4426L11.2243 16.3311L14.8668 15.2196L11.2243 14.1081L14.8668 12.9967L11.2243 11.8852L14.8668 10.7737L11.2243 9.6622L14.8668 8.55072L11.2243 7.43924L14.8668 6.32775L11.2243 5.21627L14.8668 4.11148L11.2243 3H1Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8_879",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8_879"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8_879",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQatar);
export default __webpack_public_path__ + "static/media/Qatar.873cf49b509489eb7ba2a4ea104b2778.svg";
export { ForwardRef as ReactComponent };